exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".checkbox-wrap{padding:.5rem 0;margin-bottom:1rem}.checkbox-wrap.checkbox-wrap--indent{padding-left:2rem}.checkbox__input{-webkit-appearance:none;border:1px solid rgba(0,0,0,.04);font-size:.8rem;padding:.75rem;background:rgba(0,0,0,.05);width:1.4rem;height:1.4rem;border-radius:2px;text-align:left;box-shadow:0 0 4px rgba(0,0,0,.05);outline:none;margin-right:6px;display:inline-block;vertical-align:top;position:relative}.checkbox__input:checked:after{transform:scale(1)}.checkbox__input:after{content:\"\";position:absolute;background:#06a0df;display:block;top:5px;left:5px;right:5px;bottom:5px;border-radius:1px;transform:scale(0);transition:transform .1s ease}.checkbox__label{display:inline-block;vertical-align:top;width:auto;max-width:calc(100% - 50px)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-3495e102!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Checkbox.vue
// module id = 265
// module chunks = 0